/*
  This module is not located in the "os" subdirectory, since it does not
  actually depend on Node.js or other OS APIs.
*/

/**
 * Remove platform specific invalid characters and escape double quotes.
 * Truncate name if needed as most operating systems only support upto 256 characters
 */
export const sanitizeFileName = (fileName: string, isWindows: boolean) => {
  const windowsInvalidCharacterRegex = /[\\/:"*?<>|\n\r]/g;
  const unixInvalidCharacterRegex = /\//g;

  let sanitizedName = fileName.replace(isWindows ? windowsInvalidCharacterRegex : unixInvalidCharacterRegex, '');

  sanitizedName = sanitizedName.substring(0, Math.min(256, sanitizedName.length));

  return sanitizedName;
};
